<template>
  <div :class="containerClassName">
    <slot name="label" :id="id">
      <label :for="id" v-if="!hideLabel">{{label}}<span v-if="required"> *</span></label>
    </slot>

    <div class="input-container tel" :class="inputContainerClasses" :data-symbol="symbol">
      <input
        type="text"
        autocomplete="off"
        :id="id"
        :name="name"
        :value="value"
        :class="inputClasses"
        :disabled="disabled"
        :readonly="readonly"
        :placeholder="placeholder"
        :maxlength="maxlength"
        @keydown="onKeydown"
        @input="onInput"
        @blur="onBlur"
        @focus="onFocus"
        @paste="onPaste"
      >
      <span v-if="disabled" class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-disabled"></use></svg></span>
      <span class="form-error-label" v-if="errors.has(name)">
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
        {{errors.first(name)}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThePhoneInput',
  inject: [
    '$validator'
  ],
  props: {
    label: {
      type: String,
      default: ''
    },
    containerClassName: {
      type: String,
      default: 'cell large-12'
    },
    id: {
      type: String,
      default: function () {
        return 'phone-input-id-' + this._uid
      }
    },
    name: {
      type: String,
      default: null
    },
    value: {
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    symbol: {
      type: String,
      default: null
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    maxlength: {
      type: String,
      default: null
    },
    disabled: {
      type: [Boolean, Number],
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputClasses: function () {
      let cls = []

      // Add the main class name
      cls.push(this.className)

      // Add disabled
      if (this.disabled) {
        cls.push('disabled')
      }

      // Add readonly
      if (this.readonly) {
        cls.push('readonly')
      }

      // Add error
      if (this.errors.has(this.name)) {
        cls.push('error')
      }

      return cls
    },
    inputContainerClasses: function () {
      let cls = []

      if (this.errors.has(this.name)) {
        cls.push('form-error')
      }

      if (this.disabled) {
        cls.push('disabled')
      }

      if (this.symbol) {
        cls.push('symbol-glyph')
      } else {
        cls.push('text')
      }

      return cls
    }

  },
  methods: {
    onPaste: function (e) {
      var vm = this

      // Do some replacing on paste
      setTimeout(function () {
        // Replace anything that is not 0-9, also prepend plus sign if have that
        let plus = this._.startsWith(e.target.value, '+')

        e.target.value = e.target.value.replace(/[^0-9 ]/g, '').replace(/ +/g, ' ')

        if (plus) {
          e.target.value = '+' + e.target.value
        }

        e.preventDefault()
        vm.onInput(e)
      })
    },
    onKeydown: function (e) {
      let k = e.keyCode

      // Pressed ENTER, TAB, BACKSPACE, <-, -> or 0 - 9, inc num pad
      if (e.metaKey || (k === 13 || k === 8 || k === 9 || k === 37 || k === 39) || (k >= 48 && k <= 57) || (k >= 96 && k <= 105)) {
        return true
      }

      // Plus sign allowed as first char
      if (!e.target.value && (k === 107 || k === 187)) {
        return true
      }

      if (k === 32) {
        // Sspace
        if (!e.target.value || this._.endsWith(e.target.value, ' ') || this._.endsWith(e.target.value, '-') || this._.endsWith(e.target.value, '+')) {
          e.preventDefault()
        } else {
          setTimeout(function () {
            e.target.value = e.target.value.replace(/ +/, ' ')
          })
          return true
        }
      }

      if (k === 189) {
        // Dash
        if (!e.target.value || this._.endsWith(e.target.value, ' ') || this._.endsWith(e.target.value, '-') || this._.endsWith(e.target.value, '+')) {
          e.preventDefault()
        } else {
          setTimeout(function () {
            e.target.value = e.target.value.replace(/-+/, '-')
          })
          return true
        }
      }

      if ((e.ctrlKey || e.metaKey) && (k === 17 || k === 86 || k === 67 || k === 88)) {
        return true
      }

      e.preventDefault()
    },
    onInput (e) {
      this.$emit('input', e.target.value)
    },
    onBlur (e) {
      this.$emit('blur')
    },
    onFocus (e) {
      this.$emit('focus')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Inputs/ThePhoneInput.vue